var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTpfWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 82,
    viewBox: "0 0 347 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.07 41.7464H346.899V38.4225H282.07C280.324 38.426 278.732 39.9826 278.729 41.7188V72.8486L282.07 72.8762V58.2691H333.72V54.783H282.07V41.7499V41.7464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.981 41.7464H173.631V38.4225H121.981V23.491H118.64V54.7796C118.64 56.5433 120.235 58.2657 121.981 58.2657H186.81V54.7796H121.981V41.7464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.924 41.7464H263.017V54.7796H201.924V41.7464ZM263.017 38.4225H201.924C200.181 38.4225 198.566 39.9861 198.562 41.7188V72.8486L201.924 72.8762V58.2691H263.017C264.766 58.2657 266.327 56.5364 266.327 54.783V41.7499C266.327 39.9965 264.766 38.426 263.017 38.426",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1223 38.5054L73.3351 38.6918L74.1223 39.0783V38.5054Z",
    fill: "#76B5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4138 36.8314V37.4906L23.3212 37.2766L22.4138 36.8314Z",
    fill: "#76B5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6961 14.1027V17.8442L41.835 16.6361L36.6961 14.1027Z",
    fill: "#76B5E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.835 16.6361L36.6961 14.1027V17.8442L41.835 16.6361Z",
    fill: "#5ABDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8192 61.2237L59.8434 67.6367V58.1587L46.8192 61.2237Z",
    fill: "#5ABDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.835 16.6361L59.8434 25.5033V32.0682L73.3317 38.6918L74.1223 38.5054V22.8663L55.0826 13.5159L41.835 16.6361Z",
    fill: "#5ABDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6961 34.1322V17.8442L22.4138 21.206V36.8348L23.3212 37.2766L36.6961 34.1322Z",
    fill: "#5ABDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8434 41.8672V58.1587L74.1223 54.7968V39.0783L73.3351 38.6918L59.8434 41.8672Z",
    fill: "#5ABDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8192 61.2237L36.6961 56.2361V43.845L23.3212 37.2801L22.4138 37.4906V53.0469L41.5737 62.4593L46.8192 61.2237Z",
    fill: "#5ABDFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1858 29.7798L36.6961 34.1288V43.845L41.474 46.1886L59.8434 41.8672V32.0682L55.1858 29.7798Z",
    fill: "#007DC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8434 41.8672V32.0682L55.1858 29.7798L36.6961 34.1322V43.845L41.474 46.192L59.8434 41.8672Z",
    fill: "#0067FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8434 32.0682V25.5033L41.835 16.6361L36.6961 17.8442V34.1288L55.1858 29.7798L59.8434 32.0682Z",
    fill: "#0096FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.474 46.1886L36.6961 43.845V56.2361L46.8192 61.2237L59.8434 58.1587V41.8672L41.474 46.1886Z",
    fill: "#0096FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3317 38.6918L59.8434 32.0682V41.8672L73.3317 38.6918Z",
    fill: "#0096FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3212 37.2766L36.6961 43.845V34.1322L23.3212 37.2766Z",
    fill: "#0096FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6961 0.5V14.1027L41.835 16.6361L55.0826 13.5159L74.1223 22.8663V18.9349L36.6961 0.5Z",
    fill: "#BCE4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1223 54.7968L59.8434 58.1587V67.6367L74.1223 74.671V54.7968Z",
    fill: "#BCE4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6961 14.1027L22.4138 7.07181V21.206L36.6961 17.8442V14.1027Z",
    fill: "#BCE4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4138 62.8045L59.8434 81.2429V67.6367L46.8192 61.2237L41.5737 62.4593L22.4138 53.0503V62.8045Z",
    fill: "#BCE4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.654 33.4419L74.1223 22.8663V38.5054L95.654 33.4419Z",
    fill: "#BCE4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.89917 26.2695L22.4137 36.8314V21.206L0.89917 26.2695Z",
    fill: "#BCE4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7606 49.7058L74.1223 39.0783V54.7968L95.7606 49.7058Z",
    fill: "#BCE4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00229 42.5299L22.4137 53.0503V37.4906L1.00229 42.5299Z",
    fill: "#BCE4FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 346,
    height: 81,
    fill: "white",
    transform: "translate(0.89917 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTpfWhite);
export default __webpack_public_path__ + "static/media/logo_tpf_white.318c2eed139fdb6783e880620bd27997.svg";
export { ForwardRef as ReactComponent };